import { Scorm12Runtime, build12Adapter } from './Scorm12Runtime';
import { Scorm2004Runtime, build2004Adapter } from './Scorm2004Runtime';

export function createRuntimeBridge({ version, onCommit, onTerminate }) {
  const is2004 = version === '2004';
  const runtime = is2004
    ? new Scorm2004Runtime({ onCommit, onTerminate })
    : new Scorm12Runtime({ onCommit, onTerminate });
  const adapter = is2004 ? build2004Adapter(runtime) : build12Adapter(runtime);
  return { runtime, adapter, version: is2004 ? '2004' : '1.2' };
}

export function attachApiBridge(adapter, version, iframeWindow) {
  if (version === '2004') {
    window.API_1484_11 = adapter;
    if (window.parent && window.parent !== window) {
      try { window.parent.API_1484_11 = adapter; } catch (e) { /* cross-origin */ }
    }
    if (iframeWindow) {
      try { iframeWindow.API_1484_11 = adapter; } catch (e) { /* */ }
    }
    window.API = adapter;
  } else {
    window.API = adapter;
    if (window.parent && window.parent !== window) {
      try { window.parent.API = adapter; } catch (e) { /* */ }
    }
    if (iframeWindow) {
      try { iframeWindow.API = adapter; } catch (e) { /* */ }
    }
  }
}

export function detachApiBridge() {
  try {
    delete window.API;
    delete window.API_1484_11;
  } catch (e) {
    window.API = undefined;
    window.API_1484_11 = undefined;
  }
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/runtime/createRuntimeBridge.js